export default store => {
  return {
    path: "pr-template-editor",
    getComponent(nextState, cb) {
      // require.ensure([],require => {
      const comp = require("./ProgressReportTemplateEditor").default;
      cb(null, comp);
      // },"administrator-tooling");
    },
  };
};
